import { Star, Quote, TrendingUp } from "lucide-react";
import { SOCIAL_PROOF } from "../data/mock";

export const SocialProof = () => {
  return (
    <section id="results" className="py-20 lg:py-28 bg-[hsl(220,25%,97%)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-navy-50 border border-navy-100/80 rounded-full px-4 py-1.5 mb-6">
            <TrendingUp size={13} className="text-hevi-blue" />
            <span className="text-hevi-blue font-semibold text-[11px] uppercase tracking-[0.15em]">
              {SOCIAL_PROOF.label}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold text-navy-900 leading-tight">
            A DECADE OF DELIVERING <span className="text-hevi-red">RESULTS</span> — NOT EXCUSES
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5 mb-16">
          {SOCIAL_PROOF.stats.map((stat, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl p-7 lg:p-8 text-center border border-slate-200/60 card-premium hover:shadow-xl transition-all duration-500"
            >
              <div className="text-4xl lg:text-5xl font-extrabold text-navy-900 mb-2 group-hover:text-hevi-blue transition-colors duration-400">
                {stat.value}
              </div>
              <div className="text-[11px] font-semibold text-slate-400 uppercase tracking-[0.15em]">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {SOCIAL_PROOF.testimonials.map((t, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl p-7 border border-slate-200/60 card-premium hover:shadow-xl transition-all duration-500"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-5">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} size={14} className="text-amber-400 fill-amber-400" />
                ))}
              </div>

              {/* Quote */}
              <div className="relative">
                <Quote size={20} className="text-navy-100 mb-3" />
                <p className="text-slate-500 leading-relaxed text-[14px] mb-6">
                  "{t.text}"
                </p>
              </div>

              <div className="pt-5 border-t border-slate-100">
                <p className="font-bold text-navy-900 text-sm">{t.author}</p>
                <p className="text-slate-400 text-xs mt-1">{t.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
